import React from "react";
import CategoryField from "../../executive-project-docs/fields/CategoryField";
import DownloadButton from "../../component/button/DownloadButton";
import { ReferenceListField, useFieldLabel } from "ra-friendsofbabba";
import { TextField } from "react-admin";

const DocsField = ({ tab = 3, ...props }) => {
  const fieldLabel = useFieldLabel({ resource: "executive-project-docs" });
  return (
    <ReferenceListField
      {...props}
      tab={tab}
      reference="executive-project-docs"
      target="executive_project_id"
      addLabel={false}
      createLabel="ra.action.add_doc"
      create={!props.disabled}
      modify={false}
      remove={!props.disabled}
      mobilePrimaryText="category.description"
      mobileSecondaryText="filename"
      mobileTertiaryText="subcategory.description"
      mobileBreakpoint="xs"
    >
      <CategoryField
        source="custom_category"
        label={fieldLabel("category_id")}
      />
      <TextField source="filename" label="app.filename" />
      <DownloadButton />
    </ReferenceListField>
  );
};

export default DocsField;
